document.addEventListener('alpine:init', () => {
  async function cartSection(response, section) {
    const bundled = response?.sections?.[section];
    if (typeof bundled === 'string' && bundled.trim()) return bundled;
    try {
      const url = new URL(theme.routes.cart_url, window.location.origin);
      url.searchParams.set('sections', section);
      const result = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store' });
      if (!result.ok) throw new Error('Cart section refresh failed');
      const sections = await result.json();
      if (typeof sections[section] !== 'string' || !sections[section].trim()) throw new Error('Cart section unavailable');
      return sections[section];
    } catch (error) {
      const notice = document.getElementById('cart-errors');
      if (notice) notice.textContent = theme.strings.cartError;
      console.warn('Unable to refresh cart section:', section);
      return null;
    }
  }

  Alpine.data('ThemeModule_CartFooter', (context) => {
    return {
      context: context,
      footerRoot: null,
      drawer_section: '',
      _updateVersion: 0,
      async _morphFooter(e) {
        const version = ++this._updateVersion;
        const html = await cartSection(e.detail?.response, this.drawer_section);
        if (!html || version !== this._updateVersion || !this.footerRoot?.isConnected) return;
        const newFooterSection = querySelectorInHTMLString(
          '[data-cart-footer]',
          html
        );

        if (!newFooterSection) return;
        Alpine.morph(
          this.footerRoot,
          newFooterSection.outerHTML,
          {
            updating(el, toEl, childrenOnly, skip) {
              if (
                el.classList &&
                el.classList.contains('additional-checkout-buttons')
              ) {
                skip();
              }
            },
          }
        );
      },
      init() {
        this.footerRoot = this.$root;

        if (context === 'drawer') {
          this.drawer_section = 'drawer-cart-footer';
        } else {
          this.drawer_section = 'cart-footer';
        }

        window.addEventListener('switch:cart:afteradditem', (e) => {
          this._morphFooter(e);
        });

        window.addEventListener('switch:modalcart:cartqtychange', (e) => {
          this._morphFooter(e);
        });
      },
    };
  });
});
